module.exports = __webpack_public_path__ + "static/selects-lookupmultiplaceholder-do-8d15b37d068032281db1e7b304eaa048.png";